import React, { useState, useEffect } from 'react';
import { useTheme } from '../../ThemeContext';
import { login, getEnabledSSOProviders, initiateSSOLogin } from '../../utils/auth/authService';
import { useAuth } from '../../utils/auth/AuthContext';
import { useNavigate } from 'react-router-dom';

interface LoginFormProps {
  onLoadingChange?: (loading: boolean) => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ onLoadingChange }) => {
    const { theme, isDarkMode, toggleTheme } = useTheme();
  const { login: authLogin } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [ssoProviders, setSsoProviders] = useState<Array<{ provider_id: string; name: string; provider_type: string }>>([]);
  const [loadingProviders, setLoadingProviders] = useState(true);

  useEffect(() => {
    loadSSOProviders();
  }, []);

  const loadSSOProviders = async () => {
    setLoadingProviders(true);
    if (onLoadingChange) {
      onLoadingChange(true);
    }
    try {
      const providers = await getEnabledSSOProviders();
      setSsoProviders(providers);
    } catch (err) {
      console.error('Failed to load SSO providers:', err);
    } finally {
      setLoadingProviders(false);
      if (onLoadingChange) {
        onLoadingChange(false);
      }
    }
  };

  const handleLocalLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const tokenData = await login({ username, password });
      await authLogin(tokenData.access_token);
      navigate('/');
    } catch (err) {
      setError('Invalid username or password');
    } finally {
      setLoading(false);
    }
  };

  const handleSSOLogin = async (providerId: string) => {
    try {
      const { redirect_url } = await initiateSSOLogin(providerId);
      window.location.href = redirect_url;
    } catch (err) {
      setError('Failed to initiate SSO login');
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: '0 auto' }}>
      <div style={{
        background: theme.cardBackground,
        border: `1px solid ${theme.border}`,
        borderRadius: 8,
        padding: 32,
      }}>
        <h2 style={{ color: theme.text, marginBottom: 24, textAlign: 'center' }}>Login</h2>

        {error && (
          <div style={{
            background: '#fee',
            color: '#c33',
            padding: 12,
            borderRadius: 4,
            marginBottom: 16,
            border: '1px solid #fcc',
          }}>
            {error}
          </div>
        )}

        {/*<form onSubmit={handleLocalLogin}>*/}
        {/*  <div style={{ marginBottom: 16 }}>*/}
        {/*    <label style={{ display: 'block', color: theme.text, marginBottom: 8 }}>*/}
        {/*      Username*/}
        {/*    </label>*/}
        {/*    <input*/}
        {/*      type="text"*/}
        {/*      value={username}*/}
        {/*      onChange={(e) => setUsername(e.target.value)}*/}
        {/*      style={{*/}
        {/*        width: '100%',*/}
        {/*        padding: 10,*/}
        {/*        background: theme.background,*/}
        {/*        border: `1px solid ${theme.border}`,*/}
        {/*        borderRadius: 4,*/}
        {/*        color: theme.text,*/}
        {/*        fontSize: 14,*/}
        {/*      }}*/}
        {/*      required*/}
        {/*    />*/}
        {/*  </div>*/}

        {/*  <div style={{ marginBottom: 24 }}>*/}
        {/*    <label style={{ display: 'block', color: theme.text, marginBottom: 8 }}>*/}
        {/*      Password*/}
        {/*    </label>*/}
        {/*    <input*/}
        {/*      type="password"*/}
        {/*      value={password}*/}
        {/*      onChange={(e) => setPassword(e.target.value)}*/}
        {/*      style={{*/}
        {/*        width: '100%',*/}
        {/*        padding: 10,*/}
        {/*        background: theme.background,*/}
        {/*        border: `1px solid ${theme.border}`,*/}
        {/*        borderRadius: 4,*/}
        {/*        color: theme.text,*/}
        {/*        fontSize: 14,*/}
        {/*      }}*/}
        {/*      required*/}
        {/*    />*/}
        {/*  </div>*/}

        {/*  <button*/}
        {/*    type="submit"*/}
        {/*    disabled={loading}*/}
        {/*    style={{*/}
        {/*      width: '100%',*/}
        {/*      padding: 12,*/}
        {/*      background: theme.buttonBackground,*/}
        {/*      color: theme.buttonText,*/}
        {/*      border: 'none',*/}
        {/*      borderRadius: 4,*/}
        {/*      fontSize: 16,*/}
        {/*      fontWeight: 600,*/}
        {/*      cursor: loading ? 'not-allowed' : 'pointer',*/}
        {/*      opacity: loading ? 0.6 : 1,*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    {loading ? 'Logging in...' : 'Login'}*/}
        {/*  </button>*/}
        {/*</form>*/}

        {ssoProviders.length > 0 && (
          <>
            <div style={{
              margin: '24px 0',
              textAlign: 'center',
              color: theme.textSecondary,
              position: 'relative',
            }}>
              {/*<span style={{ background: theme.cardBackground, padding: '0 16px', position: 'relative', zIndex: 1 }}>*/}
              {/*  OR*/}
              {/*</span>*/}
              <div style={{
                position: 'absolute',
                top: '50%',
                left: 0,
                right: 0,
                height: 1,
                background: theme.border,
                zIndex: 0,
              }} />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {ssoProviders.map((provider) => (
                <button
                  key={provider.provider_id}
                  onClick={() => handleSSOLogin(provider.provider_id)}
                  style={{
                    width: '100%',
                    padding: 12,
                    background: theme.background,
                    color: theme.text,
                    border: `1px solid ${theme.border}`,
                    borderRadius: 4,
                    fontSize: 14,
                    fontWeight: 500,
                    cursor: 'pointer',
                  }}
                >
                  Sign in with {provider.name}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default LoginForm;
